<template>
<router-link :to="link" class="card"
    :class="{ bgColor: !hasBg, noShadow: IDMGGuide, addPadding: hasBg }">
  <div>
    <div v-if="hasBg && link == 'incoming-shipments'">
      <img
        class="img_icon"
        src="../../../assets/update-status.png"
      /><h5>{{ title }}</h5>
    </div>
    <div v-if="link=='port-guide'">
      <img
        class="img_icon"
        src="../../../assets/read-guide.png"
      /><h5>{{ title }}</h5>
      
    </div>
    
    <div v-if="!hasBg">
      <h4>{{title}}</h4>
      <div v-if="!data">
        <h1>0</h1>
      </div>
      <div v-else>
        <h1>{{ data }}</h1>
      </div>
    </div>
  </div>
  </router-link>
</template>

<script>
export default {
  name: "DashboardCard",
  props: {
    title: String,
    data: Number,
    newApplication: Boolean,
    IDMGGuide: Boolean,
    hasBg: Boolean,
    link: String
  },
  }
</script>

<style scoped>


h4 {
  font-size: .8em;
  color: #009adb;
  text-transform: uppercase;
  font-weight: 800;
}

.noShadow {
  box-shadow: none !important;
}

h1 {
  font-size: 2em;
  color: white;
}

h5 {
  color: #003f9e;
  font-weight: 900;
  margin-top: 5px;
}

.title {
  font-size: 1.3em;
  font-weight: 700;
  color: #001038;
  border-bottom: 1px solid #001038;
  line-height: 1.8em;
}
.img_icon {
  width: 35px;
}
.addPadding {
  min-height: 150px !important;
  box-shadow: 4px 10px 23px -9px rgba(64,64,64,0.28) !important;
}
.addPadding:hover {
  box-shadow: none !important;
  cursor: pointer;
}

.card {
  margin: 0 !important;
}


</style>
